/**
 * FX kit for games (port of design/lobby/fx.js). All effects respect fxConfig:
 * reduced motion → no particles / shake / flash, 1 coin instead of many, durations ×0.3, counters jump.
 * Sound is silent until the player enables it.
 *
 *   import { fx, sound, haptic, useCelebration, wait } from '@/fx';
 *   fx.coinFly(fromEl, wallet.target(), 10);
 *   fx.countUp(el, 0, 540, 600, { prefix: '+' });
 *   fx.flash('var(--red)', fieldEl); fx.shake(fieldEl);
 *   fx.confetti(); fx.fireworks(4, boardEl);
 *   sound.play('win'); sound.play('carp/gate'); haptic('medium');
 *   music.play('lobby') — normally chosen by useMusicRoute() in the shell.
 */
import { coinFly, countUp, flash, shake, pop, burst } from './motion';
import { confetti, fireworks, clearParticles, particleCount } from './particles';
import { clearLayer } from './layer';
import { celebrate, celebrationParticles, cutCelebrations } from './celebrations';

export const fx = {
  coinFly,
  countUp,
  flash,
  shake,
  pop,
  burst,
  confetti,
  fireworks,
  /** themed celebration of a game by tier (fx/celebrations) */
  celebrate,
  /** stop all running particles, celebrations and flying coins */
  clear(): void {
    clearParticles();
    cutCelebrations();
    clearLayer();
  },
  particleCount,
  celebrationParticles,
};

export {
  sound,
  engineRate,
  LEGACY_SOUNDS,
  type SoundName,
  type LegacySoundName,
  type LoopOptions,
  type PlayOptions,
} from './sound';
export { music } from './music';
export { useMusicRoute, routeAudio, type RouteAudio } from './useMusicRoute';
export {
  AUDIO_ASSETS,
  type AudioAsset,
  type AudioGroup,
  type AudioKey,
  type SfxKey,
  type MusicTrack,
} from './audio.gen';
export { haptic, type HapticKind } from './haptics';
export { useCelebration, wait, type Celebration } from './useCelebration';
export { fxConfig, configureFx, D, cssVar } from './config';
export type { CoinFlyOptions, CountUpOptions, Point } from './motion';
export { useFxSync } from './useFxSync';
export {
  celebrate,
  celebrationTier,
  atLeast,
  CELEBRATION_MS,
  ROULETTE_COLORS,
  celebrating,
  skipCelebrations,
  type CelebrationTier,
  type CelebrateOptions,
} from './celebrations';
